<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">
        {{ $t('setting.cutOffAutomation.description') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end d-flex">
          <McButtonBack href="/setting" class="me-2" />
          <McButton
            variant="secondary"
            :text="$t('setting.cutOffAutomation.history.title')"
            icon="icon-fill_history"
            class="me-2"
            @click="$router.push({ name: 'History Setting Engine Off Automation' })"
          />
          <McButton
            variant="secondary"
            :text="$t('global.action.upload')"
            icon="icon-outline_upload"
            @click="$router.push({ name: 'Import Setting Engine Off Automation' })"
          />
        </div>
      </div>
    </div>

    <Scheduled />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McButtonBack from '@/components/McButtonBack'
import McButton from '@/components/McButton'
import { MixPanel } from '@/mixin/mixpanel'
import Scheduled from './contents/ScheduledTab'
import { mapGetters } from 'vuex'

export default {
  page: {
    title: 'Engine Off Automation',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McButton,
    Scheduled,
  },
  mixins: [MixPanel],
  computed: {
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    title() {
      return this.$t('setting.homePage.cutOffAutomation')
    },
  },
  mounted() {
    this.track('View List Engine Off Automation')
  },
}
</script>
